// extracted by css-extract-rspack-plugin
var _1 = "api-permission-prompt-m_buttons-LXEXiZpg common-m_flexRow-ZPndn63a";
export { _1 as "buttons" }
